module.exports = __webpack_public_path__ + "img/icon_bind.91b9e450.png";